import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseInputComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_STREET_INPUT_TYPE = 'postermywall-street-input';

export const POSTERMYWALL_STREET_INPUT: AddComponentTypeOptions = createBaseInputComponent({
  inputFieldType: POSTERMYWALL_STREET_INPUT_TYPE,
  inputName: 'street',
  dataMarkerAttribute: 'data-is-pmw-form-address-input',
  displayName: 'Address',
  placeholder: 'Enter street address',
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-address-input') !== null && el.getAttribute('name') === 'street',
});
